import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'location-details-dialog',
    templateUrl: 'location-details-dialog.html',
    styleUrls: ['./location-details-dialog.scss']
})
export class HomeDataLocationDetailsDialog {
    header = "Location Details"
    constructor(
        public dialogRef: MatDialogRef<HomeDataLocationDetailsDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {

    }
    cancel() {
        this.dialogRef.close();
    }
}
